import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add\"><defs><style type=\"text/css\"></style></defs><path d=\"M514 930a30 30 0 0 1-30-30V128a30 30 0 0 1 60 0v772a30 30 0 0 1-30 30z\" fill=\"#0368CD\" p-id=\"2733\" /><path d=\"M900 544H128a30 30 0 0 1 0-60h772a30 30 0 0 1 0 60z\" fill=\"#0368CD\" p-id=\"2734\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol